import { ReleaseOverview, ReleaseStatistics } from '../types';

export const FETCH_RELEASE_OVERVIEW = 'FETCH_RELEASE_OVERVIEW';

export interface ReleaseOverviewResponse extends ReleaseOverview {
    statistics: ReleaseStatistics[];
    releaseId?: string;
    appId: string;
    orgId: string;
}

export interface FetchReleaseOverviewSuccessAction {
    type: typeof FETCH_RELEASE_OVERVIEW;
    payload: ReleaseOverviewResponse;
}

export const fetchReleaseOverviewSuccess: (payload: ReleaseOverviewResponse) => FetchReleaseOverviewSuccessAction = (
    payload,
) => {
    return {
        type: FETCH_RELEASE_OVERVIEW,
        payload,
    };
};
